import {WORKSPACE_RESOURCES} from "../../../../../constants";
import workspace from "../../../core/workspace";
import {CabinetsHelper} from "../../../../../helpers/sqftCabinetsDataMapper";

export class CrownMoldingController {

  constructor() {
    this.resourceName = WORKSPACE_RESOURCES.crownMolding;
  }

  /**
   * Not used.
   */
  getCrownMoldings() {
    const shapes = workspace.getShapesWithoutAttachedResources();
    const contours = [];

    for (const shape of shapes) {
      contours.push(...this.getCrownMoldingForShape(shape.id));
    }

    return contours;
  }

  getCrownMoldingForShape(shapeId) {
    const shape = workspace.getShapeById(shapeId);
    const contours = [];

    if (shape) {
      const lines = shape.getLines();
      const contoursByFeatureId = new Map();

      for (const line of lines) {
        const isWithCrownMolding = line.isWithCrownMolding && line.isWithCrownMolding();

        if (isWithCrownMolding) {
          const featureId = line.getCrownMoldingFeatureId();
          let contour = contoursByFeatureId.get(featureId);

          if (!contour) {
            contour = {
              featureId,
              feature3dUrl: line.getCrownMolding3dURL(),
              contour_points: [],
            };
            contoursByFeatureId.set(featureId, contour);
          }

          this.addUniquePoint(contour.contour_points, line.from);
          this.addUniquePoint(contour.contour_points, line.to);
        }
      }

      if (contoursByFeatureId) {
        const posY = CabinetsHelper.getCabinetPosYFromShape(shape);
        const shapeHeight = shape.shapeCabinet ? shape.shapeCabinet.getShapeHeight() : shape.getHeight();
        contoursByFeatureId.forEach(({ featureId, feature3dUrl, contour_points }) => {
          contours.push({
            shapeId: shape.id,
            posY: posY + shapeHeight - 3.0,
            height: 3.0,
            cabinet_position: shape.getPosition(),
            featureId,
            feature3dUrl,
            contour_points
          });
        });
      }
    }

    return contours;
  }

  addUniquePoint(pointsArray, point) {
    const exists = pointsArray.some(existingPoint =>
      existingPoint.x === point.x && existingPoint.y === point.y
    );

    if (!exists) {
      pointsArray.push({x: point.x, y: point.y});
    }
  }
}

